import {
  registerOntologyMapping,
  type OntologyPropertyMapping,
  type OntologyTypeMapping,
} from '../../../core/data-profiles/OntologyPropertyMap';

const NETWORK_PROPS: OntologyPropertyMapping[] = [
  { ontologyKey: 'resourceId', runtimePath: 'attrs.resourceId', panelField: 'resourceId', type: 'string' },
  { ontologyKey: 'resourceType', runtimePath: 'attrs.resourceType', panelField: 'resourceType', type: 'string' },
  { ontologyKey: 'sourceResourceType', runtimePath: 'attrs.sourceResourceType', type: 'string' },
  { ontologyKey: 'name', runtimePath: 'attrs.name', panelField: 'name', type: 'string' },
  { ontologyKey: 'owner', runtimePath: 'attrs.owner', panelField: 'owner', type: 'string' },
  { ontologyKey: 'environment', runtimePath: 'attrs.environment', panelField: 'environment', type: 'string' },
  { ontologyKey: 'hostingProvider', runtimePath: 'attrs.hostingProvider', panelField: 'hostingProvider', type: 'string' },
  { ontologyKey: 'managedService', runtimePath: 'attrs.managedService', panelField: 'managedService', type: 'string' },
  { ontologyKey: 'service', runtimePath: 'attrs.service', panelField: 'service', type: 'string' },
  { ontologyKey: 'region', runtimePath: 'attrs.region', panelField: 'region', type: 'string' },
  { ontologyKey: 'az', runtimePath: 'attrs.az', panelField: 'az', type: 'string' },
  { ontologyKey: 'accountId', runtimePath: 'attrs.accountId', panelField: 'accountId', type: 'string' },
  { ontologyKey: 'tags', runtimePath: 'attrs.tags', panelField: 'tags', type: 'object' },
  { ontologyKey: 'encryptedAtRest', runtimePath: 'attrs.encryptedAtRest', panelField: 'encryptedAtRest', type: 'boolean' },
  { ontologyKey: 'publicExposure', runtimePath: 'attrs.publicExposure', panelField: 'publicExposure', type: 'string' },
  { ontologyKey: 'backupRetentionDays', runtimePath: 'attrs.backupRetentionDays', panelField: 'backupRetentionDays', type: 'number' },
  { ontologyKey: 'vpcId', runtimePath: 'attrs.vpcId', panelField: 'vpcId', type: 'string' },
  { ontologyKey: 'subnetId', runtimePath: 'attrs.subnetId', panelField: 'subnetId', type: 'string' },
  { ontologyKey: 'subnetType', runtimePath: 'attrs.subnetType', panelField: 'subnetType', type: 'string' },
  { ontologyKey: 'securityGroupIds', runtimePath: 'attrs.securityGroupIds', panelField: 'securityGroupIds', type: 'string[]' },
  { ontologyKey: 'isPrivilegedIdentity', runtimePath: 'attrs.isPrivilegedIdentity', panelField: 'isPrivilegedIdentity', type: 'boolean' },
  { ontologyKey: 'attachedPolicyNames', runtimePath: 'attrs.attachedPolicyNames', panelField: 'attachedPolicyNames', type: 'string[]' },
  { ontologyKey: 'adminPolicyCount', runtimePath: 'attrs.adminPolicyCount', panelField: 'adminPolicyCount', type: 'number' },
  { ontologyKey: 'scannerVerdict', runtimePath: 'attrs.scannerVerdict', panelField: 'scannerVerdict', type: 'string' },
  { ontologyKey: 'scannerSeverity', runtimePath: 'attrs.scannerSeverity', panelField: 'scannerSeverity', type: 'string' },
  { ontologyKey: 'scannerFindingRefs', runtimePath: 'attrs.scannerFindingRefs', panelField: 'scannerFindingRefs', type: 'string[]' },
  { ontologyKey: 'hasPublicIngress', runtimePath: 'attrs.hasPublicIngress', panelField: 'hasPublicIngress', type: 'boolean' },
  { ontologyKey: 'hasPublicSsh', runtimePath: 'attrs.hasPublicSsh', panelField: 'hasPublicSsh', type: 'boolean' },
  { ontologyKey: 'publicIngressRuleCount', runtimePath: 'attrs.publicIngressRuleCount', panelField: 'publicIngressRuleCount', type: 'number' },
];

function networkMapping(ontologyType: string): OntologyTypeMapping {
  return {
    ontologyType,
    runtimeType: 'network',
    unknownPropertyStrategy: 'attrs',
    properties: NETWORK_PROPS,
  };
}

export function registerNetworkOntologyMappings(): void {
  for (const ontologyType of ['place', 'artifact', 'data-store', 'actor', 'policy', 'resource-group']) {
    registerOntologyMapping(networkMapping(ontologyType));
  }
}
